import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { InfoIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useContext, useEffect, useRef, useState } from 'react';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { getShouldShowAIReportPresets } from '../utils';
import { REPORT_PRESET_TABS } from './reportPresetConstants';
import { REPORT_PRESETS_CONFIG } from './reportPresetsConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ReportPresetPills = ({
  appUsageTracker,
  onChange,
  report,
  isReportRemixChange,
  aiReportPresetFetch
}) => {
  const userInfo = useContext(UserInfoContext);
  const originalReportRef = useRef(report);
  const [selectedPresetId, setSelectedPresetId] = useState(REPORT_PRESET_TABS.DEFAULT);
  useEffect(() => {
    if (!isReportRemixChange) {
      originalReportRef.current = report;
    }
  }, [isReportRemixChange, report]);
  if (!getShouldShowAIReportPresets({
    report,
    userInfo
  })) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlock: "200",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        gap: "200",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h6",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-enablement.singleReportViewer.AIReportSummary.reportRemixes.title"
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: I18n.text('reporting-enablement.singleReportViewer.AIReportSummary.reportRemixes.tooltip'),
          children: /*#__PURE__*/_jsx(InfoIcon, {
            color: "text-primary-disabled"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "200",
      children: Object.values(REPORT_PRESET_TABS).map(presetId => {
        const Component = REPORT_PRESETS_CONFIG[presetId].component;
        return /*#__PURE__*/_jsx(Component, {
          isReportRemixChange: isReportRemixChange,
          appUsageTracker: appUsageTracker,
          report: report,
          onChange: onChange,
          selectedPresetId: selectedPresetId,
          setSelectedPresetId: setSelectedPresetId,
          aiReportPresetFetch: aiReportPresetFetch
        }, presetId);
      })
    })]
  });
};
export default ReportPresetPills;